import {setupAnalyticsPageviews} from '@github-ui/analytics-behaviors/pageviews'

setupAnalyticsPageviews()
